import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../../cmsConfig';
import { ParticipationWarningListItem } from '../../../types/Warnings/ParticipationWarningsListItem';
import dayjs from 'dayjs';

export const warningsApi = createApi({
  reducerPath: 'warningsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: cmsApiConfig.url + '/warnings',
    headers: {
      'X-CSRF': '1',
    },
    credentials: 'include',
  }),
  endpoints: (builder) => ({
    getCoachWarnings: builder.query<ParticipationWarningListItem[], void>({
      query: () => ({
        url: `/coachWarnings`,
        method: 'GET',
      }),
      transformResponse: (response: ParticipationWarningListItem[]) => {
        return response.map((item: ParticipationWarningListItem) => ({
          ...item,
          warningText: item.preliminaryWarning
            ? `Deltagaren ska slutrapporteras senast den ${item.preliminaryWarningFinalDate}`
            : 'Tiden för att slutrapportera deltagaren har överskridits',
        }));
      },
    }),
    getProviderWarnings: builder.query<ParticipationWarningListItem[], void>({
      query: () => ({
        url: `/providerWarnings`,
        method: 'GET',
      }),
      transformResponse: (response: ParticipationWarningListItem[]) => {
        return response.map((item: ParticipationWarningListItem) => ({
          ...item,
          warningText: item.preliminaryWarning
            ? `Deltagaren ska slutrapporteras senast den ${dayjs(
                item.preliminaryWarningFinalDate
              ).format('YYYY-MM-DD')}`
            : 'Tiden för att slutrapportera deltagaren har överskridits',
        }));
      },
    }),
  }),
});

export const { useLazyGetCoachWarningsQuery, useLazyGetProviderWarningsQuery } =
  warningsApi;
